import script from "./LottieIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./LottieIcon.vue?vue&type=script&setup=true&lang=js"

import "./LottieIcon.vue?vue&type=style&index=0&id=6e3a7fc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e3a7fc8"]])

export default __exports__